import axios from 'axios'

export default {
    getTeacher(params){
        return axios.get('/onlineclass/assignteacher', {params})
            .then(response => {
                return response.data
            })
    },
    insertTeacher(formdata){
        return axios.post('/onlineclass/insertteacher', formdata)
            .then(response => {
                return response.data
            })
    },
    deleteTeacher(formdata){
        return axios.post('/onlineclass/deleteteacher', formdata)
            .then(response => {
                return response.data
            })
    },
    getResultKaruniaRohani(params){
        return axios.get('/onlineclass/resultkaruniarohani', {params})
            .then(response => {
                return response.data
            })
    },
    getResultDisc(params){
        return axios.get('/onlineclass/resultdisc', {params})
            .then(response => {
                return response.data
            })
    },
    getResultQuizKomunikasi(params){
        return axios.get('/onlineclass/resultquizkomunikasi', {params})
            .then(response => {
                return response.data
            })
    },

    getKaruniaRohanibyID(id){
        return axios.get('/onlineclass/' + id + '/resultkaruniarohani')
            .then(response => {
                return response.data
            })
    },
    getResultDiscbyID(id){
        return axios.get('/onlineclass/' + id + '/resultdisc')
            .then(response => {
                return response.data
            })
    },
    getQuizKomunikasibyID(id){
        return axios.get('/onlineclass/' + id + '/resultquizkomunikasi')
            .then(response => {
                return response.data
            })
    },
  

    getResultKesehatanRohani(params){
        return axios.get('/onlineclass/resultkesehatanrohani', {params})
            .then(response => {
                return response.data
            })
    },
    getKesehatanRohanibyID(id){
        return axios.get('/onlineclass/' + id + '/resultkesehatanrohani')
            .then(response => {
                return response.data
            })
    },
    deleteResultKesehatanRohani(id){
        return axios.delete('/onlineclass/' + id +'/resultkesehatanrohani/delete')
            .then(response => {
                return response.data
            })
    },
    getSetting(){
        return axios.get('/onlineclass/resultkesehatanrohanisetting')
            .then(response => {
                return response.data
            })
    },
    updateSetting(formdata){
        return axios.post('/onlineclass/resultkesehatanrohanisetting', formdata)
            .then(response => {
                return response.data
            })
    },
}